module.exports = __webpack_public_path__ + "img/label_general.3257c0c1.png";